import { MutableRefObject } from 'react'
import { MESSAGES_SET_SELECTED_ROW_IDS, ROW_SELECT_ACTIONS } from 'messages/hooks/messagesServerSideSelectionConstants'

export type MessagesServerSideSelectionPluginApi = {
  onSelectedRowIdsChange: (ids: Record<string, boolean>) => void
  syncRowsFromSelection: (ids: Record<string, boolean>) => void
}

export const useMessagesServerSideSelectionPlugin = (
  apiRef: MutableRefObject<MessagesServerSideSelectionPluginApi>,
) => {
  const plugin = (hooks: any) => {
    hooks.stateReducers.push((state: any, action: any) => {
      if (action.type === MESSAGES_SET_SELECTED_ROW_IDS) {
        return { ...state, selectedRowIds: action.selectedRowIds || {} }
      }

      if ((ROW_SELECT_ACTIONS as readonly string[]).includes(action.type)) {
        const nextIds = { ...(state.selectedRowIds || {}) }
        const api = apiRef.current
        api.onSelectedRowIdsChange(nextIds)
        api.syncRowsFromSelection(nextIds)
      }

      return state
    })
  }

  return plugin
}
